import * as _ from 'lodash'

export default {
    states: {
        "Alabama" : "AL",
        "Alaska" :  "AK",
        "Arizona" : "AZ",
        "Arkansas" :    "AR",
        "California" :  "CA",
        "Colorado" :    "CO",
        "Connecticut" : "CT",
        "Delaware": "DE",
        "District of Columbia": "DC",
        "Florida" : "FL",
        "Georgia":  "GA",
        "Hawaii":   "HI",
        "Idaho" : "ID",
        "Illinois" :    "IL",
        "Indiana":  "IN",
        "Iowa"  :"IA",
        "Kansas":   "KS",
        "Kentucky" :    "KY",
        "Louisiana" :   "LA",
        "Maine":    "ME",
        "Maryland" :    "MD",
        "Massachusetts" :"MA",
        "Michigan"  : "MI",
        "Minnesota" :   "MN",
        "Mississippi"   : "MS",
        "Missouri"  :"MO",
        "Montana"   :"MT",
        "Nebraska": "NE",
        "Nevada"    :"NV",
        "New Hampshire" :   "NH",
        "New Jersey"    :"NJ",
        "New Mexico":   "NM",
        "New York"  :"NY",
        "North Carolina":   "NC",
        "North Dakota"  :"ND",
        "Ohio"  :"OH",
        "Oklahoma" :    "OK",
        "Oregon"    :"OR",
        "Pennsylvania" :    "PA",
        "Puerto Rico": "PR",
        "Rhode Island"  :"RI",
        "South Carolina" :  "SC",
        "South Dakota"  :"SD",
        "Tennessee" :"TN",
        "Texas":    "TX",
        "Utah"  :"UT",
        "Vermont" : "VT",
        "Virginia" :    "VA",
        "Washington" :  "WA",
        "West Virginia" :"WV",
        "Wisconsin" :   "WI",
        "Wyoming"   :"WY"        
    },
    getAbbreviationByState: function(name) {
        // return _.has(this.states[name]) ? this.states[name] : '';
        return this.states[name];
    },
    getStateByAbbreviation: function(abbr) {
        let reverse_states = _.invert(this.states);
        // return _.has(reverse_states[name]) ? reverse_states[name] : ''; 
        return reverse_states[abbr]; 
    },
    getStatesByAbbreviations: function(abbr) {
        let reverse_states = _.invert(this.states);
        let response = [];
        if (abbr && abbr.length) {
            _.each(abbr, (next_item) => {
                response.push(reverse_states[next_item])
            })
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/helpers/state-abbreviation.js